// @flow

import { cardTokenizer } from '@ebanx/ebanx-js';
import { type Country } from '@tectonics/prs/country';
import { type Card } from './types';
import { type OutgoingPaymentTokenizedCard } from './tokenized';
import { getHolderName } from './get-holder-name';
import { getNumber } from './get-number';
import { getSecurityCode } from './get-security-code';
import { getExpiryDate } from './get-expiry-date';
import { PlaceOrderError } from '../outgoing-payment';

type Args = {|
  card: Card,
  publicIntegrationKey: string,
  country: Country,
  paymentTypeCode: string,
|};

export async function tokenize({ card, publicIntegrationKey, country, paymentTypeCode }: Args): Promise<OutgoingPaymentTokenizedCard> {
  try {
    return await cardTokenizer.tokenize({
      card: {
        holderName: getHolderName(card),
        number: getNumber(card),
        cvv: getSecurityCode(card),
        dueDate: getExpiryDate(card),
      },
      countryCode: country,
      paymentTypeCode,
    });
  } catch (error) {
    throw new PlaceOrderError({
      code: 'CI-000',
      message: 'Card tokenization error',
    });
  }
}
